import React, { FC, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import Avatar from '../../../components/layout/avatar/Avatar';
import { Card } from 'react-bootstrap';
import LoadingSpinner from '../../../components/layout/loadingSpinner/LoadingSpinner';
import { useParams } from 'react-router-dom';
import usePublicForm from '../../../hooks/api/form/usePublicForm';
import EmptyList from '../../../components/layout/emptyList/EmptyList';
import { CheckCircle } from '../../../components/icons/CheckCircle';
import { getText } from '../../../utilities/CultureUtilities';
import useDimension from '../../../hooks/useDimension';

const FormConfirmPage: FC = () => {
  const pageRef = useRef<HTMLDivElement>(null);
  const { formId } = useParams<{ formId?: string | undefined }>();
  const { form, organization } = usePublicForm(formId);
  const { height } = useDimension(pageRef);
  const intl = useIntl();

  useEffect(() => {
    parent.postMessage({ id: formId, height: height + 80 }, '*');
  }, [height]);

  return (
    <div ref={pageRef} className="page-content">
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        <div className="d-flex justify-content-center">
          <Card className="flex-1 form" style={{ maxWidth: '1000px' }}>
            <Card.Body>
              {form && organization && (
                <div className="d-flex flex-column">
                  <div className="d-flex flex-row align-items-sm-end align-items-center mb-4 flex-sm-row flex-column">
                    <Avatar height={150} width={150} src={form.avatar || organization.avatar} />
                    <div className="form-confirm-name-wrapper ms-sm-4 mb-2">
                      <div className="organization-name">{organization.name}</div>
                      <div className="form-name">{getText(form.name, intl.locale)}</div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center flex-row ms-3">
                    <CheckCircle fill={'#238C9E'} width={40} height={40} />
                    <EmptyList
                      message={intl.formatMessage(
                        { id: 'formConfirmPage.successMessage' },
                        { formName: getText(form.name, '') },
                      )}
                    />
                  </div>
                </div>
              )}
              {(!organization || !form) && <LoadingSpinner />}
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default FormConfirmPage;
